import type { BeforeSendFn, CaptureResult } from 'posthog-js';

// TEMPORARY: remove once the source of the stackless "Object captured as
// exception with keys: error, isUnhandledError, meta" PostHog issue is known.
// posthog-js builds that event synchronously inside whichever browser handler
// received the object, so the dispatching event type and the call stack at
// this point name the path (onerror, onunhandledrejection, console wrapper)
// that the exception event itself does not record. Tags the event; never drops it.
const LIFECYCLE_OBJECT_MESSAGE = 'keys: error, isUnhandledError, meta';
const MAX_STACK_CHARS = 1500;

const isLifecycleObjectException = (event: CaptureResult): boolean => {
  if (event.event !== '$exception') {
    return false;
  }
  const list = (event.properties as { $exception_list?: unknown })
    ?.$exception_list;
  return (
    Array.isArray(list) &&
    list.some(
      (entry: { value?: unknown } | null) =>
        typeof entry?.value === 'string' &&
        entry.value.includes(LIFECYCLE_OBJECT_MESSAGE),
    )
  );
};

export const tagLifecycleObjectException: BeforeSendFn = (event) => {
  if (!event || !isLifecycleObjectException(event)) {
    return event;
  }
  try {
    // `window.event` is the event being dispatched; undefined outside dispatch.
    const dispatching = (window as { event?: Event }).event;
    event.properties = {
      ...event.properties,
      probe_dispatch_event_type: dispatching?.type ?? null,
      probe_dispatch_event_trusted: dispatching?.isTrusted ?? null,
      probe_capture_stack: (new Error().stack ?? '').slice(0, MAX_STACK_CHARS),
      probe_visibility: document.visibilityState,
    };
  } catch {
    // Diagnostics must never block the capture.
  }
  return event;
};
